import React, { ForwardedRef, useEffect } from "react";
import cn from "classnames";
import styles from "./PageHeader.module.scss";
import BackLink from "../BackLink";
import { ROUTES } from "src/stores/RouterStore";
import { AutoFocusInside, useAnnounce } from "@sizdevteam1/funjoiner-uikit";

type IProps = {
  className?: string;
  showBackLink?: boolean;
  onBackLinkClick?: () => void;
  backLinkRoute?: (typeof ROUTES)[keyof typeof ROUTES];
  backLinkOptions?: {
    id?: number | string;
    replace?: boolean;
    searchParams?: Record<string, string | null>;
  };
} & (
  | {
      children: React.ReactNode;
      name: string;
    }
  | {
      children: string;
      name?: undefined;
    }
);

const PageHeader = React.forwardRef(
  (
    {
      showBackLink,
      onBackLinkClick,
      backLinkRoute,
      backLinkOptions,
      children,
      className,
      name,
    }: IProps,
    ref: ForwardedRef<HTMLDivElement>,
  ) => {
    const announce = useAnnounce();
    useEffect(() => {
      const pageName = typeof children === "string" ? children : name;
      announce(`You've navigated to ${pageName}`);
    }, [announce, name, children]);
    return (
      <div
        ref={ref}
        tabIndex={-1}
        data-cy="page-header"
        className={cn("text-h1", styles.header, className)}
      >
        {showBackLink && (
          <BackLink
            route={backLinkRoute}
            options={backLinkOptions}
            onClick={onBackLinkClick}
            className={styles.backLink}
          />
        )}
        {children}
      </div>
    );
  },
);

export default PageHeader;
